import React from 'react';

import { clsx } from 'clsx';

import styles from './ButtonLink.module.css';

type TProps = {
  className?: string;
} & React.ComponentProps<'button'>;

const ButtonLink = ({ children, className, ...props }: TProps) => {
  return (
    <button className={clsx(styles.buttonLink, className)} {...props}>
      {children}
    </button>
  );
};

export default ButtonLink;
